import { useState } from 'react'
import type { SvgIconComponent } from '@mui/icons-material'
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Link as RouterLink } from 'react-router-dom'
import { BorderedIconButton } from './BorderedIconButton'

export type ActionItem = {
  label: string
  Icon: SvgIconComponent
  onClick?: () => void
  to?: string
  color?: 'error'
}

export const ActionsMenu = ({ items }: { items: ActionItem[] }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)
  const close = () => setAnchor(null)

  if (items.length === 0) return null

  return (
    <>
      <BorderedIconButton
        Icon={MoreVertIcon}
        label="Actions"
        aria-haspopup="menu"
        onClick={(e) => setAnchor(e.currentTarget)}
      />
      <Menu anchorEl={anchor} open={!!anchor} onClose={close}>
        {items.map(({ label, Icon, onClick, to, color }) => (
          <MenuItem
            key={label}
            {...(to ? { component: RouterLink, to } : {})}
            onClick={() => {
              close()
              onClick?.()
            }}
            sx={{ color: color === 'error' ? 'error.main' : undefined, minHeight: 48 }}
          >
            <ListItemIcon sx={{ color: 'inherit' }}>
              <Icon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
